// extracted by mini-css-extract-plugin
export var clickThrough = "_y4-2";
export var fallback = "_y4-5";
export var frame = "_y4-3";
export var frameCell = "_y4-1";
export var overlay = "_y4-4";
export var wrapper = "_y4-0";